export const conversationSources = ["authored", "inferred", "manual"];
export const conversationTypes = [
    "email_thread",
    "telecom_contact",
    "voice_call",
];
export const conversationEntityTypes = [
    "Placement",
    "Community",
    "Invoice",
    "ReferenceBusiness",
    "ReferenceContact",
    "HomeCareLead",
];
//# sourceMappingURL=conversation.js.map